import {
  NEW_COMMENT,
  CHANGE_COPY,
  RESET_COMMENT_TO_DEFAULTS, SET_SENTIMENT
} from "../actions/comment"


/**
 * Default comment state
 *
 * @returns {{text: string, driver: null}}
 * @private
 */
const _getDefaultState = () => ({
  text: "",
  driver: null,
  sentiment: ""
})


/**
 * Comment reducer
 *
 * @param state
 * @param action
 * @returns {{}}
 * @constructor
 */
const CommentReducer = (state = _getDefaultState(), action) => {
  const {type, ...actionProps} = action

  switch (type) {
    case NEW_COMMENT:
    case CHANGE_COPY:
    case SET_SENTIMENT:
      return {
        ...state,
        ...actionProps
      }
    case RESET_COMMENT_TO_DEFAULTS:
      return _getDefaultState()
    default:
      return state
  }
}

export default CommentReducer
